/* 🤖 this file was generated by svg-to-ts */
export const sbIconsPercentageSquare: {
  name: 'percentage-square';
  data: string;
} = {
  name: 'percentage-square',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M17 0a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M6.291 8.911a2.624 2.624 0 1 0 0-5.248 2.624 2.624 0 0 0 0 5.248m0-3.499a.875.875 0 1 1 0 1.75.875.875 0 0 1 0-1.75m7.422 5.673a2.624 2.624 0 1 0 0 5.248 2.624 2.624 0 0 0 0-5.248m0 3.499a.875.875 0 1 1 0-1.75.875.875 0 0 1 0 1.75m3.03-11.328a.874.874 0 0 0-1.236 0L3.26 15.503a.875.875 0 1 0 1.237 1.237L16.744 4.493a.874.874 0 0 0 0-1.237Z"/></svg>`
};
